// The add to cart function requires a two step process.
// Step 1: fetch the selected product metafields via storefront GraphQL query
// Step 2: if the product contains metafield data apply it as a hidden line item property
//        more on this here: https://shopify.dev/api/liquid/objects/line_item#line_item-properties

// OLD INFORMATION
// ======================
// INFOMATION is managed on the server, instead of trying to rebuild feature with local cache
// from shopify docs: "You can add an underscore to the beginning of a property name to hide it from customers at checkout. For example, properties[_hiddenPropertyName].""
// reference glow for 'hidden properties' or visit here: https://shopify.dev/api/liquid/objects/line_item#line_item-properties
// Heirachery =
// 1. product first
// 2. global
// 3. null

// STEP 1 =  await fetch METAFIELD DATA here
// -> then run the cartJS once I have the metafield
// ======================
// ======================

import { MakeGraphQLQuery } from '../../utils/helpers';
import { productMetafieldQuery } from '../../graphql/productDiscountMetafield.gql';
import { GRAPHQL_API_ENDPOINT } from '../constants';

const checkForErrors = (quantity, productHandle, selectedVariantID) => {
  if (!productHandle) {
    throw new Error('Add to cart: No productHandle supplied');
  }
  if (!quantity) {
    throw new Error('Add to cart: No quantity supplied');
  }
  if (!selectedVariantID) {
    throw new Error('Add to cart: No selectedVariantID supplied');
  }
};

const setMetafieldValues = (metafields, properties) => {
  Object.entries(metafields).forEach((metafield) => {
    const metafieldKey = metafield[0];
    const { value: metafieldValue } = metafield[1];
    if (metafieldKey && metafieldValue) {
      // the '_' is to make the line item property hidden within shopify and only render the UI
      properties[`_${metafieldKey}`] = metafieldValue;
    }
  });
};

export const appendDiscountProperties = async (productHandle, propertes) => {
  const query = productMetafieldQuery(productHandle);
  const fetchedProductMetafields = await MakeGraphQLQuery(
    GRAPHQL_API_ENDPOINT,
    query
  );
  const productMetafields = fetchedProductMetafields?.data?.product;

  const {
    discount_banner_colour,
    discount_banner_message,
    discount_banner_text_colour,
  } = productMetafields || {};

  const hasProductMetafields =
    discount_banner_colour &&
    discount_banner_message &&
    discount_banner_text_colour;

  if (hasProductMetafields) {
    setMetafieldValues(productMetafields, propertes);
  }
  return propertes;
}

export async function addToCart({
  quantity,
  productHandle,
  selectedVariantID,
  callback = {},
  lineItemProperties = {},
  source = '',
}) {
  checkForErrors(quantity, productHandle, selectedVariantID);

  // Possible value of source: // 'cross-sell-panel', 'cross-sell-cart-page', 'cross-sell-cart-drawer', ''

  let item_list_id_value = '';
  let item_list_name_value = '';

  // Add cross-sell source as a hidden line item property if from cross-sell panel
  if (source.length > 0) {
    lineItemProperties = {
      ...lineItemProperties,
      _source: source,
    };
  }

  // approach 1: listen for cartjs:addItem event and push enhanced add_to_cart event for cross-sell panel
  // Listen for cartjs:addItem event and push enhanced add_to_cart event for cross-sell panel
  // if (source === 'cross-sell-panel') {
  //   document.addEventListener('cartjs:addItem', function handler() {
  //     document.removeEventListener('cartjs:addItem', handler);
  //     if (!window.dataLayer || !window.dataLayer.length) return;
  //     const lastEvent = window.dataLayer[window.dataLayer.length - 1];
  //     if (
  //       lastEvent &&
  //       lastEvent['1'] === 'add_to_cart' &&
  //       lastEvent['2'] &&
  //       lastEvent['2'].items
  //     ) {
  //       const enhancedItems = lastEvent['2'].items.map((item) => ({
  //         ...item,
  //         item_list_name: 'Cross-Sell Panel',
  //       }));
  //       const enhancedEvent = {
  //         ...lastEvent['2'],
  //         item_list_name: 'Cross-Sell Panel',
  //         items: enhancedItems,
  //       };

  //       // Fire enhanced gtag event
  //       if (window.gtag) {
  //         window.gtag('event', 'add_to_cart', enhancedEvent);
  //       }

  //       // alternatively, use dataLayer.push, we had this on quickshop, quick_shop vs quickAdd
  //       // window.dataLayer.push({
  //       //   event: 'add_to_cart',
  //       //   ecommerce: {
  //       //     ...enhancedEvent,
  //       //   },
  //       // });
  //     }
  //   });
  // }

  // approach 2: intercepting the gtag event for cross-sell panel
  if (source.length > 0) {
    let eventBlocked = false;
    let originalEventData = null;
    const originalPush = window.dataLayer?.push;

    if (!originalPush) return; // Safety check

    if (source === 'cross-sell-panel') {
      item_list_id_value = 'cross_sell_panel';
      item_list_name_value = 'Cross-Sell Panel';
    } else if (source === 'cross-sell-cart-page') {
      item_list_id_value = 'cross_sell_cart_page';
      item_list_name_value = 'Cross-Sell Cart Page';
    } else if (source === 'cross-sell-cart-drawer') {
      item_list_id_value = 'cross_sell_cart_drawer';
      item_list_name_value = 'Cross-Sell Cart Drawer';
    }

    window.dataLayer.push = function (...args) {
      const filteredArgs = args.filter((arg) => {
        // Check if this is an add_to_cart event from integration
        if (
          arg?.['0'] === 'event' &&
          arg?.['1'] === 'add_to_cart' &&
          arg?.['2']?.items &&
          !eventBlocked
        ) {
          originalEventData = arg;
          return false; // Block original event
        }
        return true;
      });

      return filteredArgs.length > 0
        ? originalPush.apply(this, filteredArgs)
        : undefined;
    };

    document.addEventListener('cartjs:addItem', function handler() {
      document.removeEventListener('cartjs:addItem', handler);

      setTimeout(() => {
        const eventData = originalEventData || window.dataLayer?.slice(-1)[0];

        if (eventData?.['2']?.items) {
          const enhancedEventData = {
            ...eventData['2'],
            // item_list_id: item_list_id_value,
            // item_list_name: item_list_name_value,
            items: eventData['2'].items.map((item) => ({
              ...item,
              item_list_id: item_list_id_value,
              item_list_name: item_list_name_value,
            })),
          };

          // console.log(`✅ Pushing enhanced add_to_cart event to dataLayer: `, enhancedEventData);

          // Also create a simplified event for easier GTM tracking
          const simplifiedXSellEvent = {
            event: 'add_to_cart_xsell',
            productName: enhancedEventData.items.map(item => `${item.name} | ${item.item_list_name}`).join(', '),
          };

          eventBlocked = true;
          window.gtag?.('event', 'add_to_cart', enhancedEventData);
          window.dataLayer?.push(simplifiedXSellEvent);

          setTimeout(() => {
            eventBlocked = false;
            originalEventData = null;
          }, 1000);
        }
      }, 150);
    });
  }

  const CartJS = window.CartJS || {};
  const query = productMetafieldQuery(productHandle);
  const fetchedProductMetafields = await MakeGraphQLQuery(
    GRAPHQL_API_ENDPOINT,
    query
  );
  const productMetafields = fetchedProductMetafields?.data?.product;

  const cartJsOptions = {
    ...callback,
    success: function(data, textStatus, jqXHR) {
      document.dispatchEvent(
        new CustomEvent("cartjs:addItem", {
          detail: { successData: data },
        })
      );

      if (callback?.success) {
        callback.success(data, textStatus, jqXHR);
      }
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.error('addToCart() Error: ' + errorThrown + '!');
    },
  };

  const {
    discount_banner_colour,
    discount_banner_message,
    discount_banner_text_colour,
  } = productMetafields || {};

  const hasProductMetafields =
    discount_banner_colour &&
    discount_banner_message &&
    discount_banner_text_colour;

  if (hasProductMetafields) {
    setMetafieldValues(productMetafields, lineItemProperties);
  }

  appendDiscountProperties(productHandle, lineItemProperties);
  // STEP 2 =  await is check if data exists and apply as propeties
  await CartJS.addItem(
    selectedVariantID,
    quantity,
    lineItemProperties,
    cartJsOptions
  );
}
